import React, { useState } from "react";

import axios from "axios";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { swalCustom } from "../../../../utils/functions";
import ModalApp from "components/ModalApp";
import { FormNewCard } from "components/FormCard";
import { cardsApi } from "page/OrderResumePag/_services/api";
import notify from "components/UI/toast";
import pagarme from "pagarme/browser";
import { setLoading } from "Redux/cartSlice";
import { useUserData } from "hooks/UserContext";
import { trackCallbackMarketplace, trackClick } from "../../../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../../../hooks/useScreenTracking";

export function RegisterNewCard({
  addresses,
  cards,
  setRefreshCards,
  onSaveCard,
  Loading,
}) {
  const [boxNewCard, setBoxNewCard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const screenName = useScreenTracking();

  const { user } = useUserData();

  function onClickDelCard(uuid_Card) {
    trackClick({
      title: "excluir-cartao",
      contentType: "cartoes-cadastrados",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });
    
    // Verifica se é o único cartão cadastrado
    if (cards.length === 1) {
      notify(
        "Este cartão não pode ser excluído enquanto não houver outro cartão cadastrado.",
        "error",
      );
      return;
    }

    swalCustom
      .fire({
        html: '<p class="fw-bold fs-5 mb-0">Deseja excluir este item?</p>',
        showCancelButton: true,
        confirmButtonText: "EXCLUIR",
        cancelButtonText: "CANCELAR",
        icon: "question",
      })
      .then((result) => {
        if (result.isConfirmed) {
          try {
            cardsApi
              .delete(`/v1/customer/${user.cpf}/card/${uuid_Card}`)
              .then((result) => {

                trackCallbackMarketplace({
                  contentType: "excluir-cartao",
                  screenName: `marketplace-${screenName}`,
                  status: !result.status ? "erro" : "sucesso",
                });
                
                if (!result.status) {
                  return notify(result.message, "error");
                }
                notify("Cartão removido com sucesso", "success");
                setRefreshCards(new Date());
                return;
              });
          } catch (err) {
            notify("Erro ao deletar cartão.", "error");
          }
        } else if (result.dismiss) {
          trackClick({
            title: "cancelar-exclusao-cartao",
            contentType: "cadastrar-novo-cartao",
            screenName,
            tagId: tagIdFromLegacySuffix("08"),
          });
        }
      });
  }

  const toggleOpenModal = () => {
    if (!addresses || (addresses && !addresses.length)) {
      notify("Você precisa de um endereço para cadastrar um cartão.", "error");
      return;
    }

    trackClick({
      title: "adicionar",
      contentType: "cartoes-cadastrados",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });
    
    setBoxNewCard(!boxNewCard);
  };

  const saveNewCard = async (values) => {
    setIsLoading(true);
    const card_pagarme = {
      card_number: values.card_number,
      card_holder_name: values.card_holder_name,
      card_expiration_date: values.card_expiration_date?.replace("/", ""),
      card_cvv: values.card_cvv,
    };
    let cardValidations = pagarme.validate({ card: card_pagarme });

    if (!cardValidations.card.card_holder_name) {
      notify("Verifique o nome impresso no cartão.", "error");
      return false;
    }
    if (!cardValidations.card.card_number) {
      notify("Verifique o número do cartão.", "error");
      return false;
    }
    if (!cardValidations.card.card_expiration_date) {
      notify("Verifique a data de expiração do cartão.", "error");
      return false;
    }
    if (!cardValidations.card.card_cvv) {
      notify("Verifique o código de segurança (CVV) do cartão.", "error");
      return false;
    }

    let card_hash = null;

    const cardNumber = values.card_number.replaceAll(" ", "");
    const expirationMonth = values.card_expiration_date.split("/")[0];
    const expirationYear = values.card_expiration_date.split("/")[1];

    const payload = {
      type: "card",
      card: {
        number: cardNumber,
        holder_name: values.card_holder_name,
        exp_month: expirationMonth,
        exp_year: expirationYear,
        cvv: values.card_cvv,
      },
    };

    const options = {
      method: "POST",
      url: `${process.env.REACT_APP_PAGARME_API}?appId=${process.env.REACT_APP_PAGARME_APPID}`,
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
      data: payload,
    };

    const { data, status } = await axios.request(options);

    trackCallbackMarketplace({
      status: status == 200 ? "sucesso" : "erro",
      contentType: "cadastrar-novo-cartao",
      screenName: `marketplace-${screenName}`,
    });

    if (status !== 200) {
      notify("Erro ao cadastrar dados do cartão.", "error");
      return;
    }

    card_hash = data?.id;

    await onSaveCard(values, card_hash);
    setIsLoading(false);
    setBoxNewCard(false);
  };

  return (
    <>
      <ModalApp show={boxNewCard} handleModal={() => {
        trackClick({
          title: "fechar-modal",
          contentType: "cadastrar-novo-cartao",
          screenName,
          tagId: tagIdFromLegacySuffix("08"),
        });
        setBoxNewCard(false);
      }}>
        <FormNewCard
          saveNewCard={saveNewCard}
          onCancel={toggleOpenModal}
          cards={cards}
          isMyAccountPage={true}
          Loading={Loading}
        />
      </ModalApp>
      {cards.length > 0 ? (
        cards.map((card, index) => {
          return (
            <div
              key={index}
              className="d-flex align-items-center justify-content-between"
            >
              <div className="d-flex align-items-center gap-2">
                <label>{card.brand} -</label>
                <label htmlFor="radio1">Final {card.last_four_digits}</label>
              </div>

              <button
                className="btn link-cancel-wl font-wl-500 text-xs"
                onClick={() => onClickDelCard(card.uuid)}
              >
                EXCLUIR
              </button>
            </div>
          );
        })
      ) : (
        <p className="font-wl-500">Nenhum cartão cadastrado</p>
      )}
      <Row>
        <Col className="my-4">
          <button
            className="btn-outline-wl px-4 py-2 text-xs font-wl-700"
            style={{ width: "fit-content" }}
            onClick={toggleOpenModal}
          >
            ADICIONAR CARTÃO
          </button>
        </Col>
      </Row>
    </>
  );
}

RegisterNewCard.propTypes = {
  addresses: PropTypes.array,
  cards: PropTypes.array,
  setRefreshCards: PropTypes.func,
  onSaveCard: PropTypes.func,
  Loading: PropTypes.bool,
};
